var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/people"
  }, /*#__PURE__*/React.createElement("g", {
    id: "people"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.9981 7.34018C17.9381 7.33018 17.8681 7.33018 17.8081 7.34018C16.4281 7.29018 15.3281 6.16018 15.3281 4.76018C15.3281 3.33018 16.4781 2.18018 17.9081 2.18018C19.3381 2.18018 20.4881 3.34018 20.4881 4.76018C20.4781 6.16018 19.3781 7.29018 17.9981 7.34018Z",
    stroke: "#C4D26E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.9675 14.6203C18.3375 14.8503 19.8475 14.6103 20.9075 13.9003C22.3175 12.9603 22.3175 11.4203 20.9075 10.4803C19.8375 9.77034 18.3075 9.53033 16.9375 9.77033",
    stroke: "#C4D26E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.97047 7.34018C6.03047 7.33018 6.10047 7.33018 6.16047 7.34018C7.54047 7.29018 8.64047 6.16018 8.64047 4.76018C8.64047 3.33018 7.49047 2.18018 6.06047 2.18018C4.63047 2.18018 3.48047 3.34018 3.48047 4.76018C3.49047 6.16018 4.59047 7.29018 5.97047 7.34018Z",
    stroke: "#C4D26E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.0014 14.6203C5.6314 14.8503 4.12141 14.6103 3.06141 13.9003C1.65141 12.9603 1.65141 11.4203 3.06141 10.4803C4.13141 9.77034 5.6614 9.53033 7.0314 9.77033",
    stroke: "#C4D26E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.9981 14.8104C11.9381 14.8004 11.8681 14.8004 11.8081 14.8104C10.4281 14.7604 9.32812 13.6304 9.32812 12.2304C9.32812 10.8004 10.4781 9.65039 11.9081 9.65039C13.3381 9.65039 14.4881 10.8104 14.4881 12.2304C14.4781 13.6304 13.3781 14.7704 11.9981 14.8104Z",
    stroke: "#C4D26E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9.08875 17.9605C7.67875 18.9005 7.67875 20.4405 9.08875 21.3805C10.6888 22.4505 13.3087 22.4505 14.9087 21.3805C16.3187 20.4405 16.3187 18.9005 14.9087 17.9605C13.3187 16.9005 10.6888 16.9005 9.08875 17.9605Z",
    stroke: "#C4D26E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.cd5fc79276ba2b47de08a38971edd5ab.svg";
export { ForwardRef as ReactComponent };